
const _draw = Symbol('_draw');
const _createPattern = Symbol('_createPattern');

export default class MagicPencil{
	constructor() {
		// Constants.
		this.LINE_THICKNESS = 5;
		// Attributes.
		this._drawLayer = null;
		this._textureId = null;
	}

	init(drawLayer) {
		this._drawLayer = drawLayer;
	}

	onDrawBegan(point){
		this._drawLayer.context.lineWidth = this.LINE_THICKNESS;
		this._drawLayer.context.lineJoin = this._drawLayer.context.lineCap = 'round';
		this._drawLayer.context.strokeStyle = this[_createPattern]();

		this[_draw](point, point);
	}

	onDrawMoved(from, to){
		this[_draw](from, to);
	}

	onDrawEnded(){
	}

	[_draw](from, to){
		this._drawLayer.context.beginPath();
		this._drawLayer.context.moveTo( from.x, from.y );
		this._drawLayer.context.lineTo( to.x, to.y );
		this._drawLayer.context.stroke();

		this._drawLayer.onContext_Changed();
	}

	[_createPattern](){
		const patternCanvas = document.createElement('canvas');
		const ctx = patternCanvas.getContext('2d');
		const texture = P3.assets.texture(this._textureId);
		const frame = texture.frame;
		patternCanvas.width = patternCanvas.height = frame.width;

		ctx.drawImage(texture.baseTexture.source, frame.x, frame.y, frame.width, frame.height, 0, 0, frame.width, frame.height);

		return ctx.createPattern(patternCanvas, 'repeat');
	}

	set textureId(value){
		this._textureId = value;
	}
}